export default __webpack_public_path__ + "68240322512945535ef6d5c7a5eb3c9e.png";